// import "@datadog/browser-rum/bundle/datadog-rum";

import { loadConfig } from "./config";
import { oTelTracer } from "./otel/otelTrace";

const initializeTracer = async () => {
  const config = await loadConfig()
  oTelTracer(config)
};

export default initializeTracer;
